import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldX, ArrowLeft, Home, User } from 'lucide-react';

const AccessDenied = ({ 
  title = "Acceso Denegado", 
  message = "No tienes permisos para acceder a esta página.",
  showBackButton = true,
  showHomeButton = true,
  showProfileButton = true 
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        {/* Icono */}
        <div className="mx-auto mb-6 w-20 h-20 bg-red-100 rounded-full flex items-center justify-center">
          <ShieldX className="w-10 h-10 text-red-600" />
        </div>

        {/* Título */}
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          {title}
        </h1>

        {/* Mensaje */}
        <p className="text-gray-600 mb-8 leading-relaxed">
          {message}
        </p>

        {/* Botones de acción */}
        <div className="space-y-3">
          {showBackButton && (
            <button
              onClick={() => window.history.back()}
              className="w-full flex items-center justify-center gap-2 px-4 py-3 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-200 rounded-lg hover:bg-gray-200 transition-all duration-200"
            >
              <ArrowLeft className="w-4 h-4" />
              Volver
            </button>
          )}

          {showHomeButton && (
            <Link
              to="/courses/getCourses"
              className="w-full flex items-center justify-center gap-2 px-4 py-3 text-sm font-medium text-white bg-green-aqua border border-green-aqua rounded-lg hover:bg-green-aqua/90 transition-all duration-200"
            >
              <Home className="w-4 h-4" />
              Ir a Cursos
            </Link>
          )}

          {showProfileButton && (
            <Link
              to="/specific/courseProfile"
              className="w-full flex items-center justify-center gap-2 px-4 py-3 text-sm font-medium text-green-aqua bg-green-aqua/10 border border-green-aqua/20 rounded-lg hover:bg-green-aqua/20 transition-all duration-200"
            >
              <User className="w-4 h-4" />
              Mi Perfil
            </Link>
          )}
        </div>

        {/* Información adicional */}
        <div className="mt-8 pt-6 border-t border-gray-100">
          <p className="text-xs text-gray-500">
            Si crees que esto es un error, contacta al administrador del sistema.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AccessDenied; 